(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbIconDataStore', ['$q', '$sce', 'smbIconService', IconDataStore]);

	/**
	 * @typedef {Object} Icon
	 * @property {String} IconFriendlyUserName A human readable label for an icon
	 * @property {String} IconExtension The icon data type as a capitalized version of the extension
	 * @property {String} IconUri The url to get the icon data
	 */

	function IconDataStore($q, $sce, smbIconService) {
		var _icons;

		return {
			get icons() { return _icons; },
			loadIcons: loadIcons,
			getIconData: getIconData
		};

		function loadIcons() {
			if (!_icons) {
				return smbIconService.getIcons()
					.then(function(data) {
						_icons = data;
						return data;
					});
			} else {
				return $q.resolve(_icons);
			}
		}

		function getIconData(icon) {
			return smbIconService.getIconData(icon.IconUri, icon.IconExtension)
				.then(function(data) {
					var iconImage = { isBinary: data.isBinary };
					if (data.isBinary) {
						var blob = new Blob([data.imageData], {type: data.contentType});
						var objUrl = URL.createObjectURL(blob);
						iconImage.data = objUrl;
					} else {
						iconImage.data = $sce.trustAsHtml(data.imageData);
					}
					return iconImage;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/iconDataStore.js
// module id = 124
// module chunks = 1